export enum TripType {
  OneWay = 'One-Way',
  RoundTrip = 'Round-Trip',
  None = 'None',
}

export enum TripDirection {
  Arrival = 'Arrival',
  Departure = 'Departure',
  None = 'None',
}

export interface TripDetail {
  tripType: TripType;
  tripDirection: TripDirection;
  guestCount: number;
  tripId?: string;
  tripDescription?: string;
  specialRequirements?: string;
}

export enum ApiTripType {
  ARRIVAL_ONLY_TRIP = 'ArrivalOnlyTrip',
  DEPARTURE_ONLY_TRIP = 'DepartureOnlyTrip',
  ROUND_TRIP = 'RoundTrip',
  NONE = 'None',
}
